import { QueryMode, StringFilter } from '@/@generated/codegen/API';

export const parseStringQueryParam = (value: string | undefined): StringFilter | undefined => {
  if (!value) return undefined;
  const stringFilter: StringFilter = {
    contains: value,
    mode: QueryMode.Insensitive,
  };
  return stringFilter;
};
